/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DownloadIcon = ({ width = 24, height = 24, hidden = false, title = 'Download' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 24h-2a1 1 0 0 0-1 1v5H6v-5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
    <path
      d="M17.65 26.856a.5.5 0 0 0 .7 0l7.446-7.525a.785.785 0 0 0 .204-.526.8.8 0 0 0-.802-.805H20V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v15h-5.198a.8.8 0 0 0-.802.805.785.785 0 0 0 .204.526Z"
    />
  </svg>`;
};
